module.exports = kolibriCoreAppGlobal.utils.licenseTranslations;